import { LogLevel } from '@shared/logger';
import { z } from 'zod';

/**
 * Parse and validate the configuration.
 *
 * Use `z.string()` to parse string values.
 * Use `z.coerce.number()` to parse number values.
 * Use `z.coerce.boolean()` to parse boolean values.
 */
export default z.object({
  mode: z.enum(['development', 'production', 'staging', 'uat']),
  logLevel: z.nativeEnum(LogLevel).default(LogLevel.INFO),
  graphql: z.object({
    apiUrl: z.string().min(1).url(),
    defaultFetchPolicy: z
      .enum(['cache-first', 'network-only', 'cache-only', 'no-cache', 'standby'])
      .optional(),
  }),
  loginUrl: z.string().min(1).url(),
  userSessionApiUrl: z.string().min(1).url(),
  deepLinkUrl: z.string().min(1).url(),
  userManagement: z.object({
    url: z.string().min(1).url(),
    internalUserEmailDomains: z.string().transform((v) => {
      if (v === '') {
        return [];
      }
      return v.split(',').map((s) => s.trim());
    }),
  }),
  examCenter: z.object({
    adminMemberRoleId: z.string(),
    defaultLogoSrc: z.string().url(),
  }),
  examinee: z.object({
    importTemplateUrl: z.string().url(),
  }),
  examEvent: z.object({
    paperAnswer: z.object({
      importTemplateUrl: z.string().url(),
      spreadsheetSheetName: z.string(),
    }),
  }),
  proctor: z.object({
    agreementFormTemplateUrl: z.string().url(),
    agreementFormTemplateUrlTypeOneAndTwo: z.string().url(),
    agreementFormTemplateUrlTypeThree: z.string().url(),
  }),
});
